import { Api } from '@coderhouse/common'
import { FooterItem, IFooterItem } from '@/models/footer'

const { VUE_APP_HOME_SERVICE } = process.env

async function getFooterItems(country: string): Promise<FooterItem[]> {
  const footer = await Api.get(`${VUE_APP_HOME_SERVICE}/api/v1/footer?country=${country}`)
  const items = footer.map((item: IFooterItem) => new FooterItem(item))
  return items
}

export { getFooterItems }
